
export class Departamento {
    departamentoid: number = 0;
    nombre: string = "";
    tipodepartamentoid: number = 0;
    departamentosuperiorid: number = 0;
    nivel: boolean = false;
    nivelid: number = 0;
    areaacademica: boolean = false;
    areaacademicaid: number = 0;
    activo: boolean = true;

    constructor(init?: Partial<Departamento>) {
        Object.assign(this, init);
    }
}
